import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Tag from '../../../Tags/Tag';
import discover from '../../../../assets/recommended/discover.png';
import { setCurrentCourse } from '../../../../store/actions/appActions';
import { COURSES } from '../../../../constants/courses';
import { CoursesModifications } from '../../../../types/courses/courses';

import { RestoreWrapper, TagsWrapper, RestoreImage, RestoreContent, RestoreBottom } from './styled';
import useMediaQuery from '../../../../utils/breakpoints/useMediaQuery';

const DiscoverProgressio = () => {
   const { t } = useTranslation();
   const dispatch = useDispatch();
   const { isMobile } = useMediaQuery();

   const handleSelectCourse = () => {
      dispatch(setCurrentCourse({ courseModification: COURSES.discoverHorizonsProposal as CoursesModifications }));
   }

   return (
      <Link to={`/cabinet/${COURSES.discoverHorizonsProposal}`} >
         <RestoreWrapper onClick={handleSelectCourse} isMobile={isMobile}>
            <RestoreImage isMobile={isMobile} src={discover} />
            <RestoreContent isMobile={isMobile} >
               <TagsWrapper>
                  <Tag name="Teens" />
               </TagsWrapper>
               <RestoreBottom isMobile={isMobile}> 
                  <h1>{t('course.discoverHorizons.title')}</h1>
                  <p>{t('course.discoverHorizons.description')}</p>
            </RestoreBottom>  
            </RestoreContent>
         </RestoreWrapper>
      </Link>
   );
};

export default DiscoverProgressio;